import { ErrorMapping } from 'core/types/error-mapping';
import { GraphqlError } from 'core/utils/backend-service';
import { TFunction } from 'core/i18n/i18n';
import { DeviceFormValidation } from 'modules/devices/pods/private-pods/devices-add-edit/types/device-form';

export const COPY_FORM_ERRORS_MAPPINGS: ErrorMapping[] = [
    { field: 'name', errorCode: 'E_POC_ADM_DM_0097', type: 'duplicated' },
];
export const newDeviceCopyFormValidation: DeviceFormValidation = {
    name: { state: 'valid' },
};
export const getCustomFormError = (formErrors: GraphqlError[], fieldName: string) =>
    Object.entries(COPY_FORM_ERRORS_MAPPINGS)
        .filter(
            ([, mapping]) =>
                formErrors.some((e) => e.extensions.code === mapping.errorCode) && mapping.field === fieldName
        )
        .map(([, mapping]) => mapping.type);

export const customErrorMessages = (t: TFunction) => ({
    name: {
        error: {
            duplicated: t('modules.devices.pods.devices-list.copy-from-modal.name.validation.duplicated'),
        },
    },
});
